"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _botframeworkWebchatApi = require("botframework-webchat-api");

var _react = _interopRequireDefault(require("react"));

var _ScreenReaderText = _interopRequireDefault(require("../ScreenReaderText"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var useLocalizer = _botframeworkWebchatApi.hooks.useLocalizer;

var ConnectivityStatusConnected = function ConnectivityStatusConnected() {
  var localize = useLocalizer();
  return /*#__PURE__*/_react.default.createElement(_ScreenReaderText.default, {
    text: localize('CONNECTIVITY_STATUS_ALT', localize('CONNECTIVITY_STATUS_ALT_CONNECTED'))
  });
};

var _default = ConnectivityStatusConnected;
exports.default = _default;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9Db25uZWN0aXZpdHlTdGF0dXMvQ29ubmVjdGVkLmpzIl0sIm5hbWVzIjpbInVzZUxvY2FsaXplciIsImhvb2tzIiwiQ29ubmVjdGl2aXR5U3RhdHVzQ29ubmVjdGVkIiwibG9jYWxpemUiXSwibWFwcGluZ3MiOiI7Ozs7Ozs7QUFBQTs7QUFDQTs7QUFFQTs7OztBQUVBLElBQVFBLFlBQVIsR0FBeUJDLDZCQUF6QixDQUFRRCxZQUFSOztBQUVBLElBQU1FLDJCQUEyQixHQUFHLFNBQTlCQSwyQkFBOEIsR0FBTTtBQUN4QyxNQUFNQyxRQUFRLEdBQUdILFlBQVksRUFBN0I7QUFFQSxzQkFBTyw2QkFBQyx5QkFBRDtBQUFrQixJQUFBLElBQUksRUFBRUcsUUFBUSxDQUFDLHlCQUFELEVBQTRCQSxRQUFRLENBQUMsbUNBQUQsQ0FBcEM7QUFBaEMsSUFBUDtBQUNELENBSkQ7O2VBTWVELDJCIiwic291cmNlUm9vdCI6ImNvbXBvbmVudDovLy8iLCJzb3VyY2VzQ29udGVudCI6WyJpbXBvcnQgeyBob29rcyB9IGZyb20gJ2JvdGZyYW1ld29yay13ZWJjaGF0LWFwaSc7XG5pbXBvcnQgUmVhY3QgZnJvbSAncmVhY3QnO1xuXG5pbXBvcnQgU2NyZWVuUmVhZGVyVGV4dCBmcm9tICcuLi9TY3JlZW5SZWFkZXJUZXh0JztcblxuY29uc3QgeyB1c2VMb2NhbGl6ZXIgfSA9IGhvb2tzO1xuXG5jb25zdCBDb25uZWN0aXZpdHlTdGF0dXNDb25uZWN0ZWQgPSAoKSA9PiB7XG4gIGNvbnN0IGxvY2FsaXplID0gdXNlTG9jYWxpemVyKCk7XG5cbiAgcmV0dXJuIDxTY3JlZW5SZWFkZXJUZXh0IHRleHQ9e2xvY2FsaXplKCdDT05ORUNUSVZJVFlfU1RBVFVTX0FMVCcsIGxvY2FsaXplKCdDT05ORUNUSVZJVFlfU1RBVFVTX0FMVF9DT05ORUNURUQnKSl9IC8+O1xufTtcblxuZXhwb3J0IGRlZmF1bHQgQ29ubmVjdGl2aXR5U3RhdHVzQ29ubmVjdGVkO1xuIl19